import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { Button, InputWrapper } from '..';
import type { MtFormButtonsProps } from './types';
import * as Styled from './styled';

export * from './types';

export const MtFormButtons: FC<MtFormButtonsProps> = (props) => {
  const {
    showCancel,
    showNext,
    showPrevious,
    showSubmit,
    cancelDisabled = false,
    previousDisabled = false,
    nextDisabled = false,
    submitDisabled = false,
    cancelLoading = false,
    previousLoading = false,
    nextLoading = false,
    submitLoading = false,
    onCancelClick,
    onNextClick,
    onPreviousClick,
    onSubmitClick,
    sticky = false,
    children,
    ...rest
  } = props;
  const { translate } = useTranslation();

  return (
    <Styled.MtFormButtonsContainer sticky={sticky} {...rest}>
      {!showCancel && !showPrevious && !showSubmit && showNext && <InputWrapper split />}

      {showCancel && (
        <InputWrapper split noMargin={sticky} whiteBackground={sticky}>
          <Button
            outlined
            color="blue"
            onClick={onCancelClick}
            disabled={cancelDisabled}
            loading={cancelLoading}
          >
            {translate('common.buttons.cancel')}
          </Button>
        </InputWrapper>
      )}
      {showPrevious && (
        <InputWrapper split noMargin={sticky}>
          <Button
            color="blue"
            outlined
            onClick={onPreviousClick}
            disabled={previousDisabled}
            loading={previousLoading}
            type="button"
          >
            {translate('common.buttons.previous')}
          </Button>
        </InputWrapper>
      )}
      {showNext && (
        <InputWrapper split noMargin={sticky}>
          <Button color="blue" onClick={onNextClick} disabled={nextDisabled} loading={nextLoading}>
            {translate('common.buttons.next')}
          </Button>
        </InputWrapper>
      )}
      {showSubmit && (
        <InputWrapper split noMargin={sticky} last={sticky}>
          <Button
            color="blue"
            onClick={onSubmitClick}
            disabled={submitDisabled}
            loading={submitLoading}
            type="submit"
          >
            {translate('common.buttons.save')}
          </Button>
        </InputWrapper>
      )}
    </Styled.MtFormButtonsContainer>
  );
};
